import React, { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, firestore } from "../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import ConfirmModal from "../components/ConfirmModal"; // ✅ eklendi

function Home() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState("");
  const [showLogoutModal, setShowLogoutModal] = useState(false); // ✅

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      if (currentUser) {
        let nameToShow = "";

        try {
          const userRef = doc(firestore, "users", currentUser.uid);
          const docSnap = await getDoc(userRef);

          if (docSnap.exists() && docSnap.data().name) {
            nameToShow = docSnap.data().name;
          }

          if (currentUser.email === "gozdetaspinar@icloud.com") {
            nameToShow = "❤️Tuğba Gözde Şimşek❤️";
          }

          if (!nameToShow) {
            nameToShow = currentUser.email;
          }

          setUserName(nameToShow);
        } catch (err) {
          console.error("Kullanıcı adı çekilirken hata oluştu:", err);
          setUserName(currentUser.email);
        }
      }
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  const sections = [
    { emoji: "📅", label: "Rezervasyon Oluştur", route: "/rezervasyon-olustur" },
    { emoji: "🗓️", label: "Takvim Görünümü", route: "/takvim" },
    { emoji: "🎨", label: "Konsept Görselleri", route: "/konsept-gorselleri" },
    { emoji: "🧰", label: "Malzeme Görselleri", route: "/malzeme-gorselleri" },
    { emoji: "📋", label: "Rezervasyonlar", route: "/rezervasyonlar" },
  ];

  return (
    <div>
      {user && (
        <div
          style={{
            position: "absolute",
            top: "1rem",
            right: "1rem",
            backgroundColor: "#f9f9f9",
            padding: "10px 15px",
            borderRadius: "10px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            display: "flex",
            alignItems: "center",
            gap: "10px"
          }}
        >
          <span style={{ fontWeight: "bold" }}>{userName}</span>
          <button
            onClick={() => setShowLogoutModal(true)} // ✅ burada sadece modal açılıyor
            style={{
              padding: "6px 10px",
              backgroundColor: "#4f46e5",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer"
            }}
          >
            Çıkış Yap
          </button>
        </div>
      )}

      <h1 style={{
  textAlign: "center",
  marginTop: "5rem",
  fontWeight: "bold",
  fontSize: "2.5rem",
  fontFamily: "'Dancing Script', cursive"
}}>
  🎀 <span style={{ color: "#ec4899" }}>Gözde</span> Organizasyon Paneli
</h1>



      <div className="sections-container">
        {sections.map((sec, i) => (
          <div
            className="section-card"
            key={i}
            onClick={() => navigate(sec.route)}
          >
            <span className="emoji">{sec.emoji}</span>
            <span>{sec.label}</span>
          </div>
        ))}
      </div>

      {/* ✅ Çıkış modalı */}
      {showLogoutModal && (
        <ConfirmModal
          message="Çıkış yapmak istediğine emin misin?"
          onConfirm={handleLogout}
          onCancel={() => setShowLogoutModal(false)}
        />
      )}
    </div>
  );
}

export default Home;
